import Image from "@/components/Image";
import type { BasicTeam } from "@/graphql/gql/graphql";
import styles from "./TeamCell.module.scss";

type TeamCellProps = Pick<BasicTeam, "abbreviation" | "logoSVG">;

const TeamCell = ({ abbreviation, logoSVG }: TeamCellProps) => (
  <div className={styles.cell}>
    <Image
      width={30}
      height={30}
      src={logoSVG ?? ""}
      alt={abbreviation ?? ""}
      className={styles.logo}
    />
    {abbreviation}
  </div>
);

export default TeamCell;
